const IntegracaoGupyStatusEnum = Object.freeze({
    PROCESSANDO: 'Processando',
    ERRO_CRIAR_FUNCIONARIO: 'Erro ao cadastrar funcionário',
    ERRO_CRIAR_AGENDAMENTO: 'Erro ao criar agendamento',
    SUCESSO: 'Sucesso',
    CANCELADO: 'Cancelado'
});

export default IntegracaoGupyStatusEnum;
